import React from 'react';
import {faqs} from "./FaqData";

export function Faq() {

    return (
        <div className={"container"}>
            <h1 className={"text-center mt-5 border-bottom pb-3"}>Ofte stilte spørsmål</h1>
            {
                faqs.map(item => (
                    <div className={"my-5"}>

                        <h3 className={"fw-bold"}>{item.question}</h3>
                        <p className={"text-justify"}>{item.answer}</p>

                    </div>
                ))
            }
        </div>
    );

}